import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPendingAssets } from 'packages/store/assets/assets.selectors';
import { updateAssetsStatus } from 'packages/store/assets/assets.actions';
import { updateCollectionsThumbnails } from 'packages/store/collections/collections.actions';
import { useSseSubscribe, sseAssetsStatusOptions } from 'packages/sse';
import useSuperSet from './useSuperSet';

const emptyAssetsIds: string[] = [];

export default function useAssetStatusUpdates() {
    const pendingAssets: string[] = useSelector(getPendingAssets);

    const dispatch = useDispatch();

    // prevents unnecessary re-subscriptions when pendingIds change
    // the array stays the same until there is no new items in pendingIds
    const memoizedPendingIds = useSuperSet(pendingAssets);
    const assetIds = pendingAssets.length ? memoizedPendingIds : emptyAssetsIds;

    const subscribe = useSseSubscribe(
        sseAssetsStatusOptions({
            assetIds,
            onMessage: (items) => {
                dispatch(updateAssetsStatus(items));
                dispatch(updateCollectionsThumbnails(items));
            },
        }),
    );

    useEffect(() => {
        if (!assetIds.length) {
            return;
        }

        return subscribe();
    }, [subscribe, assetIds]);
}
